//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchAlpha from "./components/SearchAlpha";
import SearchBox from "./components/SearchBox";
import SearchFilters from "./components/SearchFilters";
import SearchHeader from "./components/SearchHeader";
import SearchResults from "./components/search-results/Results";
import SearchResultsLenders from "./components/search-results/Lenders";
import SearchPagination from "./components/SearchPagination";
import SearchLoader from "./components/Loader";
import TopFilters from "./components/TopFilters";
import VueScrollTo from "vue-scrollto";

export default {
  name: "SearchApp",
  components: {
    SearchAlpha,
    SearchLoader,
    SearchBox,
    SearchFilters,
    SearchHeader,
    SearchResults,
    SearchResultsLenders,
    SearchPagination,
    TopFilters,
  },
  methods: {
    setQuery(data) {
      // sets the search text
      this.changeOnlyOneParam("q", data);
      //this.changeOnlyOneParam("p", 0);
      this.$store.commit("setQuery", data);
      //this.$store.commit('setPageIndex', 0);
      //this.executeSearch();
      this.setPage(0);
    },
    setPage(data) {
      // sets the page from pagination

      // Scroll to top
      VueScrollTo.scrollTo(
        this.resultsType === 'lender' ? "#search-app" : ".section-header__heading", 
        {
          force: false,
          offset: -1 * (window.innerHeight / 3)
        }
      );

      this.changeOnlyOneParam("p", data);
      this.$store.commit("setPageIndex", data);
      this.executeSearch();
    },
    setFilters(data) {
      // sets the filters
      this.changeOnlyOneParam("c", this.getFilterQuerystring(data));
      this.$store.commit("setFilters", data);
      // Scroll to top
      VueScrollTo.scrollTo(
        this.resultsType === 'lender' ? "#search-app" : ".section-header__heading", 
        {
          force: false,
          offset: -1 * (window.innerHeight / 3)
        }
      );
      // always reset to page 0
      this.$store.commit("setPageIndex", 0);
      this.executeSearch();
    },
    executeSearch() {
      this.isLoaded = false;
      const searchUrl = this.$store.state.settings.searchUrl;
      if (searchUrl) {
        postData(searchUrl, this.$store.state.searchQuery)
          .then((response) => {
            this.$store.commit("setResults", response);

            if (this.selectedPageIndex > this.results.totalPages - 1) {
              this.$store.commit("setPageIndex", 0);
            }
          })
          .finally(() => {
            setTimeout(() => {
              this.isLoaded = true;
            }, 300)
          });
      }
    },
    changeOnlyOneParam(paramName, changeTo) {
      var params = JSON.parse(JSON.stringify(this.$route.query));
      params[paramName] = changeTo;

      this.$router
        .push({
          query: params,
        })
        .catch(() => {});
    },
    getFilterQuerystring(filters) {
      var ids = [];
      filters.forEach(function (parent) {
        var set = parent.filters
          .filter((c) => c.selected == true)
          .map((a) => a.id);

        if (set.length > 0) {
          ids.push(set);
        }
      });

      return ids.join(",");
    },
  },
  computed: {
    results() {
      return this.$store.state.results;
    },
    searchQuery() {
      return this.$store.state.searchQuery;
    },
    selectedPageIndex() {
      return this.$store.state.selectedPageIndex;
    },
    shouldHeaderBeShown() {
      return !this.$root.hideQueryTextbox;
    },
    shouldTopFiltersBeShown() {
      return this.$root.showTopFilters === "true";
    },
    shouldPaginationBeShown() {
      return (
        this.$store.state.results.totalResultCount >
        this.$store.state.results.pageSize
      );
    },
    shouldFiltersBeShown() {
      return (
        this.$root.showCategories === "true" ||
        this.$root.showContentType === "true"
      );
    },
    shouldSearchBoxBeShown() {
      return this.$root.showSearchBox === "true";
    },
    shouldShowContentType() {
      return this.$root.showContentType === "true";
    },
    shouldShowCategories() {
      return this.$root.showCategories === "true";
    },
    shouldStackRail() {
      return this.$root.stackedRail === "true";
    },
    showSortByAlpha() {
      return this.$root.showSortByAlpha;
    },
    resultsType() {
      return this.$root.resultsType;
    },
    searchPos() {
      return this.$store.state.settings.searchBoxPlacement;
    },
    getFilterGroups() {
      if (this.$root.filterGroups) {
        let filterGroups = this.$root.filterGroups.split(",");

        return filterGroups.filter((x) => x !== null && x != "");
      }

      return [];
    },
  },
  data: function () {
    return {
      isLoaded: false,
    };
  },
  created() {
    // Get default settings, allow for overrides in the app markup
    var settings = this.$store.state.settings;

    settings.searchUrl = this.$root.searchUrl;

    // Conditionally override default values for text
    if (this.$root.headerText)
      settings.headerText = this.$root.headerText;

    if (this.$root.searchPlaceholder)
      settings.searchPlaceholder = this.$root.searchPlaceholder;

    if (this.$root.searchButtonText)
      settings.searchButtonText = this.$root.searchButtonText;

    if (this.$root.filterText)
      settings.filterText = this.$root.filterText;

    if (this.$root.filterButtonText)
      settings.filterButtonText = this.$root.filterButtonText;

    if (this.$root.noResultsText)
      settings.noResultsText = this.$root.noResultsText;

    if (this.$root.searchBoxPlacement)
      settings.searchBoxPlacement = this.$root.searchBoxPlacement;

    if (this.$root.searchSortby)
      this.$store.commit("setSearchSortBy", this.$root.searchSortby);

    if (this.$root.resultsType)
      this.$store.commit("setResultsType", this.$root.resultsType);

    settings.stackedRail = ("true" === this.$root.stackedRail);
    settings.horizontalFilters = ("true" === this.$root.horizontalFilters);
    settings.showFilterButton = ("true" === this.$root.showFilterButton);
    settings.showCategories = ("true" === this.$root.showCategories);
    settings.showSearchBox = ("true" === this.$root.showSearchBox);
    settings.showContentType = ("true" === this.$root.showContentType);

    // Get any html we're injecting
    const includedHTML = {};
    document.querySelectorAll(".search-app__html-include").forEach((el) => {
      if (el.dataset.slot)
        includedHTML[el.dataset.slot] = el.innerHTML;
    });
    settings.includedHTML = includedHTML;

    // Set data to store
    this.$store.commit("setSettings", settings);
    this.$store.commit("setSearchIndex", this.$root.searchIndex);
    this.$store.commit("setPageSize", this.$root.pageSize);
    this.$store.commit("setFilterGroups", this.$root.filterGroups);
    this.$store.commit("setShowSortByAlpha", this.$root.showSortByAlpha);
    this.$store.commit(
      "setShowContentType",
      ("true" === this.$root.showContentType)
    );

    // Check URL to see if any parameters are set
    if (this.$route.query.q) {
      this.$store.commit("setQuery", this.$route.query.q);
    }

    // Check if the query has been hard-coded in the embed tag
    if (this.$root.searchTerm) {
      this.$store.commit("setQuery", this.$root.searchTerm);
    } else {
      // Check URL to see if any parameters are set
      if (this.$route.query.q) {
        this.$store.commit("setQuery", this.$route.query.q);
      }
    }

    if (this.$route.query.p) {
      this.$store.commit("setPageIndex", this.$route.query.p);
    }

    this.executeSearch();
  },
};

async function postData(url = "", data = {}) {
  const response = await fetch(url, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
    body: JSON.stringify(data),
  });

  return response.json();
}
